import {TaxAccountantRequestResModel} from "@/shared/api/tax-accountant/dto/TaxAccountantRequestResModel";
import {z} from "zod";

export const taxAccountantRequestFormSchema = z.object({
	type: z.string(),
	before: TaxAccountantRequestResModel.model,
	after: TaxAccountantRequestResModel.model
});

export type TaxAccountantRequestFormType = z.infer<typeof taxAccountantRequestFormSchema>;
